import { BaseModel } from '../core/abstractions/base.model';

export class ShareInfoModel extends BaseModel {
    group: string;
    label: string;
    registeredShares: number;
    value: number;

    constructor(init: Partial<ShareInfoModel>) {
        super();
        Object.assign(this, init);
    }
}
